export enum EButtonType {
  primaryAccented = 'primary-accented',
  primaryNeutral = 'primary-neutral',
  secondaryAccented = 'secondary-accented',
  secondaryNeutral = 'secondary-neutral',
  tetriaryOutlined = 'tertiary-outlined',
  tetriaryGhost = 'tertiary-ghost',
  quaternaryAccented = 'quaternary-accented',
  quaternaryNeutral = 'quaternary-neutral',
  quaternaryDark = 'quaternary-dark',
}
